export default __webpack_public_path__ + "static/media/lampas11-min.c0be9e5d.jpeg";